/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  SmsSentDto,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    SmsSentDtoFromJSON,
    SmsSentDtoToJSON,
} from '../models';

export interface SendPaymentReminderRequest {
    locationId: string;
    reference: string;
}

/**
 * 
 */
export class SendPaymentReminderControllerApi extends runtime.BaseAPI {

    /**
     */
    async sendPaymentReminderRaw(requestParameters: SendPaymentReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmsSentDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling sendPaymentReminder.');
        }

        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling sendPaymentReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/locations/{locationId}/digital-bills/{reference}/payment-reminder`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmsSentDtoFromJSON(jsonValue));
    }

    /**
     */
    async sendPaymentReminder(requestParameters: SendPaymentReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmsSentDto> {
        const response = await this.sendPaymentReminderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
